import React, { useEffect, useRef } from "react";
import { useState } from "react";
import "react-phone-input-2/lib/style.css";
import "./login.css";
import login_img from "../../assets/images/login_img.png";
import eye from "../../assets/images/eye.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { api } from "../../api/api";
import logo from "../../assets/images/logo.png";
import { useForm } from "react-hook-form";
import CustomInput from "../common/Input/Input";
import { ReactComponent as Arrow } from "../../assets/images/arrow-left.svg";

const EmployeePassword = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const employeeId = searchParams.get("employeeId");

  // console.log(value, otp, "otp");
  const {
    register,
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const newPassword = watch("newPassword");

  const handlelogin = async (data) => {
    if (otp.some((digit) => digit.trim() === "")) {
      setError("Please enter all OTP fields.");
      return;
    } else {
      setError();
    }
    console.log(data, "form");

    const otpNumber = Number(otp.join(""));
    var payload = {
      oldPassword: data?.oldPassword,
      newPassword: data?.newPassword,
      otp: otpNumber,
    };

    let res = await api(
      `api/v1/employee/changePassword/${employeeId}`,
      payload,
      "putWithoutToken",
      "",
      "Password Change Successfully"
    );
    if (res && res.success) {
      // setSubscriptionData(res?.data);
      console.log(res.data, res, "card");

      navigate("/");
    }
  };
  const registerOptions = {
    oldPassword: { required: "Old password is required" },
    newPassword: { required: "New password is required" },

    confirmPassword: {
      required: "Confirm password is required",
      validate: (value) => value === newPassword || "Passwords do not match",
    },
  };

  // Handle OTP input change
  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move to next input if a digit is entered
      if (value !== "" && index < 5) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  // Handle Backspace for previous input
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      if (otp[index]) {
        newOtp[index] = ""; // Clear current input
      } else if (index > 0) {
        inputRefs.current[index - 1].focus(); // Move to previous input
      }
      setOtp(newOtp);
    }
  };

  return (
    <>
      <div className="loginModal">
        <div className="container-fluid">
          <div className="row">
            <div className="login_left">
              <div className="images">
                {/* <p>
                  Secure Access to Smarter
                  <br /> Hospital Management.
                </p> */}
                <img src={login_img} />
              </div>
            </div>
            <div className="login_reight">
              <div className="login-content">
                <div>
                  <img src={logo} alt="" />
                </div>

                <form className="w-100" onSubmit={handleSubmit(handlelogin)}>
                  <h6>
                    <span onClick={() => navigate(-1)}>
                      <Arrow />
                    </span>
                    {/* <img src={Arrow} /> */}
                    Create New Password
                  </h6>
                  <div className="otp_section mx-auto">
                    <div className="mb-3 ">
                      <span className="mb-1 input_lable d-block">
                        Please enter the otp that sent to email
                      </span>
                      <div className="d-flex justify-content-between">
                        {otp.map((digit, index) => (
                          <input
                            key={index}
                            type="text"
                            className="form-control text-center otp-input"
                            maxLength={1}
                            value={digit}
                            onChange={(e) => handleChange(e, index)}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            ref={(el) => (inputRefs.current[index] = el)}
                          />
                        ))}
                      </div>
                      <small className="error">{error}</small>
                    </div>
                  </div>
                  <CustomInput
                    register={register}
                    label="Old Password"
                    name="oldPassword"
                    placeholder="e.g."
                    type="text"
                    errors={errors.oldPassword}
                    validation={registerOptions.oldPassword}
                  />
                  <CustomInput
                    register={register}
                    label="New Password"
                    name="newPassword"
                    placeholder="e.g"
                    type="text"
                    errors={errors.newPassword}
                    validation={registerOptions.newPassword}
                  />
                  <CustomInput
                    register={register}
                    label="Confirm Password"
                    name="confirmPassword"
                    placeholder="e.g"
                    type="text"
                    errors={errors.confirmPassword}
                    validation={registerOptions.confirmPassword}
                  />

                  <button
                    className="mx-auto d-block btn_primary w-100 mb-5 mt-5" // onClick={() => navigate("/dashboard")}
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeePassword;
